import React, { Component } from "react";
import SingleCatCard from "../table/SingleCatCard";
import { Divider, Row, Layout } from "antd";
import ReactGA from "react-ga4";
import throttle from "lodash.throttle";
import PropTypes from "prop-types";
import axios from "axios";
// import CatLevels from "../settings/CatLevels";

const { Content } = Layout;

export const initGA = () => {
  ReactGA.initialize(
    "G-MX6GYDK28N"
    // , {
    //   gaAddress: "https://onestoppress.com:5000/analytics.js"
    // }
  );
};

export const logPageView = () => {
  ReactGA.set({ page: window.location.pathname + window.location.search });
};

class SingleCat extends Component {
  constructor(props) {
    super(props);
    this.state = {
      viewportWidth: 0,
      selectedCats: [],
    };

    this.getCatForms.bind(this);
  }

  componentDidMount() {
    this.saveViewportDimensions();
    window.addEventListener("resize", this.saveViewportDimensions);

    // initGA();
    // logPageView();

    const { catno } = this.props.match.params;

    document.title =
      this.props.match.params.catname + " | 냥코 대전쟁 위키: 냥코 스탯";

    axios
      .post("https://onestoppress.com/api/singlecatflagKR", {
        compare: (catno + "-" + 1).toString(),
      })
      .then((res) => {
        let catone = res.data.sampledata;
        if (
          res.data.hasOwnProperty("sampledata") &&
          catone !== "그런 유닛은 존재하지 않습니다"
        ) {
          this.setState((prevState) => ({
            selectedCats: [...prevState.selectedCats, catone],
          }));

          return axios
            .post("https://onestoppress.com/api/singlecatflagKR", {
              compare: (catno + "-" + 2).toString(),
            })
            .then((res) => {
              let cattwo = res.data.sampledata;
              if (
                res.data.hasOwnProperty("sampledata") &&
                cattwo !== "그런 유닛은 존재하지 않습니다"
              ) {
                this.setState((prevState) => ({
                  selectedCats: [...prevState.selectedCats, cattwo],
                }));
                // console.log(cattwo);
                return axios
                  .post("https://onestoppress.com/api/singlecatflagKR", {
                    compare: (catno + "-" + 3).toString(),
                  })
                  .then((res) => {
                    let catthree = res.data.sampledata;
                    if (
                      res.data.hasOwnProperty("sampledata") &&
                      catthree !== "그런 유닛은 존재하지 않습니다"
                    ) {
                      this.setState((prevState) => ({
                        selectedCats: [...prevState.selectedCats, catthree],
                      }));
                      // console.log(catthree);
                      return axios
                        .post("https://onestoppress.com/api/singlecatflagKR", {
                          compare: (catno + "-" + 4).toString(),
                        })
                        .then((res) => {
                          let catfour = res.data.sampledata;
                          if (
                            res.data.hasOwnProperty("sampledata") &&
                            catfour !== "그런 유닛은 존재하지 않습니다"
                          ) {
                            this.setState((prevState) => ({
                              selectedCats: [
                                ...prevState.selectedCats,
                                catfour,
                              ],
                            }));
                          }
                        });
                    }
                  });
                // .then(console.log(this.state.selectedCats));
              }
            });
        }
      });
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.saveViewportDimensions);
  }

  saveViewportDimensions = throttle(() => {
    let adjustViewport;
    if (window.innerWidth < 636) {
      adjustViewport = 22;
    } else if (window.innerWidth < 948) {
      adjustViewport = 34;
    } else {
      adjustViewport = 46;
    }
    this.setState({
      viewportWidth: window.innerWidth - adjustViewport,
    });
  }, this.props.applyViewportChange);

  getCatForms() {
    const { catno } = this.props.match.params;
    const catforms = [];
    let i;
    for (i = 1; i < this.state.selectedCats.length + 1; i++) {
      catforms.push(
        <SingleCatCard
          viewportWidth={this.state.viewportWidth}
          catform={i}
          catno={catno}
          key={i}
          selectedCat={this.state.selectedCats[i - 1]}
        />
      );
    }
    return catforms;
  }

  render() {
    const cardWidth =
      this.props.viewportWidth > 948
        ? this.props.viewportWidth / 3 - 4
        : this.props.viewportWidth > 636
        ? this.props.viewportWidth / 2 - 6
        : this.props.viewportWidth - 24;

    return (
      <div>
        <div className="pagetitle">
          <h1
            style={{
              padding: "10px 0 0 0",
              marginBottom: "6px",
              maxWidth: this.state.viewportWidth - 104,
              float: "left",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              overflow: "hidden",
            }}
          >
            냥코 정보
          </h1>
          <Divider style={{ margin: "0 0 0 0", padding: "0 0 0 0" }} />
        </div>
        <Layout style={{ padding: "0 12px 0 12px", background: "white" }}>
          <Content style={{ padding: "0 0px" }}>
            <div>
              <Row style={{ padding: "16px 0 0px 0" }}>
                {this.getCatForms()}

                <div
                  style={{
                    // borderRadius: "8px",
                    padding: "4px",
                    minWidth: "350px",
                    maxWidth: "400px",
                    height: "550px !important",
                    width: cardWidth,
                    display: "inline-block",
                    verticalAlign: "top",
                  }}
                >
                </div>
              </Row>
            </div>
          </Content>
        </Layout>
      </div>
    );
  }
}

export default SingleCat;

SingleCat.propTypes = {
  applyViewportChange: PropTypes.number,
};

SingleCat.defaultProps = {
  applyViewportChange: 250,
};



// WEBPACK FOOTER //
// ./src/components-kr/content/SingleCat.js